import { errorFromResponse, NetworkError } from "./errors.js";

const path = projectId => `/api/projects/${encodeURIComponent(projectId)}/media`;
async function request(url, options = {}) {
  let response;
  try { response = await fetch(url, { credentials: "same-origin", ...options }); }
  catch (err) { throw new NetworkError(err.message); }
  if (!response.ok) throw await errorFromResponse(response);
  return response.json();
}
export async function getProjectMedia(projectId) {
  const result = await request(path(projectId));
  if (!Array.isArray(result?.items) || typeof result?.capabilities?.canManage !== "boolean") throw new Error("The server returned an invalid media list.");
  return result;
}
export function uploadProjectMedia(projectId, file, weekDate) {
  const body = new FormData();
  body.append("file", file);
  if (weekDate) body.append("weekDate", weekDate);
  return request(path(projectId), { method: "POST", body });
}
export function updateProjectMedia(projectId, mediaId, caption, weekDate) {
  return request(`${path(projectId)}/${encodeURIComponent(mediaId)}`, {
    method: "PATCH", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ caption, ...(weekDate ? { weekDate } : {}) }),
  });
}
export function removeProjectMedia(projectId, mediaId, confirmation, weekDate) {
  return request(`${path(projectId)}/${encodeURIComponent(mediaId)}`, {
    method: "DELETE", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ confirmation, ...(weekDate ? { weekDate } : {}) }),
  });
}
